import React, { FC, ReactElement, ReactNode } from 'react';
import { CardComponentsProps } from './types';

const CardHeader: FC<CardComponentsProps> = ({ children, className }): ReactElement => {
    return (
        <div className={className}>{children}</div>
    );
};

export { CardHeader };